module.exports = __webpack_public_path__ + "media/images/burger-47e5500ac4a4520bdbb2f4f2eaf9b84d.svg";